import { useDispatch, useSelector } from 'react-redux';
import { useRequestSections } from '../api/request';
import { useMutation } from '@tanstack/react-query';
import { RootState } from '../redux/Store';
import { useFindPermissions } from '../utils/helpers/useFindPermissions';
import Notifications from '../ui/molecules/toast/Notifications';
import { setLuggageData } from '../redux/reducer/inspact/order_reducer';

const useWorkOrderLuggage = () => {
  const { Luggage } = useRequestSections();
  const { canViewWorkOrderLiteLuggage } = useFindPermissions();
  const dispatch = useDispatch();

  const {
    mutateAsync: getWorkOrderLuggage,
    data: workOrderLuggage,
    isPending: workOrderLuggagePending,
    isSuccess: workOrderLuggageSuccessful,
    isError: workOrderLuggageError,
  } = useMutation({
    mutationFn: async ({ loanId, orderNumber }: any) => {
      // checkPermission(
      //   permissions,
      //   Permissions?.CAN_VIEW_WORKORDER_LITE_LUGGAGE
      // );
      if (canViewWorkOrderLiteLuggage) {
        const response = await Luggage?.getLuggageSV(loanId, orderNumber);
        dispatch(setLuggageData(response?.data));
        return response?.data;
      } else
        return Notifications(
          'You do not have permission to view work order luggage',
          0
        );
    },
  });
  return {
    getWorkOrderLuggage,
    workOrderLuggage,
    workOrderLuggagePending,
    workOrderLuggageSuccessful,
    workOrderLuggageError,
  };
};

export default useWorkOrderLuggage;
